import { isBrowser } from 'es-toolkit';
import { transformAuthResponse, transformDeviceGrantSessionResponse, } from './transforms';
export class AuthService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    reauth() {
        return this.#requestClient.reauth();
    }
    beginDeviceGrantSession(params) {
        const { sku } = params || {};
        return this.#requestClient.fetch({
            method: 'post',
            url: `${this.#storeClient.options.domains.opml}/Account.ashx`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            params: {
                c: 'beginDeviceGrantSession',
                sku,
            },
            transform: transformDeviceGrantSessionResponse,
        });
    }
    acceptDeviceGrant(params) {
        const { deviceCode } = params || {};
        return this.#requestClient.fetch({
            method: 'post',
            url: `${this.#storeClient.options.domains.opml}/Account.ashx`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            params: {
                c: 'acceptDeviceGrant',
                generateAuth: true,
                deviceCode,
            },
            transform: transformAuthResponse,
        });
    }
    logout() {
        const { proxyReauthMode, domains } = this.#storeClient.options;
        if (!isBrowser() || proxyReauthMode === 'disabled') {
            return this.#requestClient.fetch({
                method: 'post',
                url: `${domains.opml}/Account.ashx`,
                params: { c: 'drop' },
            });
        }
        return this.#requestClient.fetch({
            method: 'post',
            url: `${domains.local}/auth/logout`,
        });
    }
    setTokens(authTokens) {
        const { domains } = this.#storeClient.options;
        if (!isBrowser()) {
            console.warn('[WARN] setTokens call ignored on server. This is a client-side-only API.');
            return Promise.resolve();
        }
        return this.#requestClient.fetch({
            url: `${domains.local}/auth/setTokens`,
            post: authTokens,
        });
    }
    clearTokens() {
        const { domains } = this.#storeClient.options;
        if (!isBrowser()) {
            console.warn('[WARN] setTokens call ignored on server. This is a client-side-only API.');
            return Promise.resolve();
        }
        return this.#requestClient.fetch({
            method: 'post',
            url: `${domains.local}/auth/clearTokens`,
        });
    }
}
